import {StopPredictionData} from './stopprediction.data.model';

export class StopPrediction {
  message: string;
  url: string;
  stopId: string;
  name: string;
  providerId: string;
  lat: number;
  lon: number;
  routes: string[];
  data: StopPredictionData[];
  liveData: StopPredictionData[];

  deserialize(input: any) {
    (<any>Object).assign(this, input);


    this.liveData = input.liveData.map((item) => new StopPredictionData().deserialize(item));
    this.data = input.data.map((item) => new StopPredictionData().deserialize(item));

    this.routes.sort((route1: string, route2: string): number => {
      let result: number;
      result = parseInt(route1, 10) - parseInt(route2, 10);

      if (result === 0 || Number.isNaN(result)) {
        return route1.localeCompare(route2);
      } else {
        return result;
      }
    });

    if (this.url !== null && this.url !== undefined) {
      this.url = unescape(this.url);
    }
    if (this.message !== null && this.message !== undefined) {
      this.message = unescape(this.message);
    }

    return this;
  }

  getData(): StopPredictionData[] {
    const combined: StopPredictionData[] = [];
    combined.push(...this.liveData);
    combined.push(...this.data);

    return combined;
  }

}
